import { render, staticRenderFns } from "./EnumDictLabel.vue?vue&type=template&id=3eaf52c1&scoped=true"
import script from "./EnumDictLabel.vue?vue&type=script&lang=js"
export * from "./EnumDictLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf52c1",
  null
  
)

export default component.exports